module.exports = "pegasus/assets/background-patterns/theme4_theme.gif";